/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";
/*REDUX*/
import {
  set_value_sini_data,
  get_history_sini_data,
  delete_item_sini_data,
  edit_title_sini_data,
} from "../../App/actions/sini_data_actions";
import { Button } from "@mui/material";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/

/*CONST*/

class S_D_HISTORY extends Component {
  state = {
    modalRename: false,
    title: "",
    anchorEl: null, // null = menu tertutup
    selectedItem: null, // item history yg diklik
  };

  componentDidMount() {
    const { sini_data_history } = this.props.sini_data_reducer;
    if (sini_data_history.length === 0) {
      const { geo_project } = this.props.project;
      this.props.get_history_sini_data({ project_id: geo_project?._id });
    }
  }

  handleOpenMenu = (e, item) => {
    e.stopPropagation();
    this.setState({ anchorEl: e.currentTarget, selectedItem: item });
  };

  handleCloseMenu = () => this.setState({ anchorEl: null });

  handleEdit = () => {
    const { selectedItem } = this.state;
    if (!selectedItem) return;

    this.setState({
      modalRename: true,
      title: selectedItem.title || "",
      anchorEl: null, // tutup menu
    });
  };

  handleDelete = () => {
    const { selectedItem } = this.state;
    if (!selectedItem) return;

    this.props.delete_item_sini_data(selectedItem);
    this.setState({ anchorEl: null }); // tutup menu
  };
  on_click_item = (sini_data_selected) => {
    this.props.set_value_sini_data({
      key: "chat_list",
      value: sini_data_selected?.chat_list || [],
    });
    this.props.set_value_sini_data({
      key: "request_id",
      value: sini_data_selected?.request_id,
    });
    this.props.set_value_sini_data({
      key: "menu_sidebar",
      value: "chat",
    });
  };

  handleSaveTitle = () => {
    const { title, selectedItem } = this.state;
    this.props.edit_title_sini_data({
      title,
      request_id: selectedItem.request_id,
    });
    this.setState({ modalRename: false });
  };

  render() {
    const { sini_data_history } = this.props.sini_data_reducer;
    const { modalRename, title, anchorEl } = this.state;

    return (
      <main>
        {modalRename && (
          <Modal
            modalSize="small"
            isOpen={modalRename}
            onClose={() => this.setState({ modalRename: false })}
          >
            <h2>Edit Title</h2>
            <input
              name="title"
              value={title}
              onChange={(e) => this.setState({ title: e.target.value })}
            />
            <Button onClick={this.handleSaveTitle}>Update</Button>
          </Modal>
        )}

        <h1 className="margin_bottom">History</h1>

        {sini_data_history.map((item, idx) => (
          <div
            key={item.request_id ?? idx}
            className="container background_grey_light margin_bottom cursor_pointer"
            style={{ display: "flex", justifyContent: "space-between" }}
            onClick={() => this.on_click_item(item)}
          >
            {item.title || `Chat ${idx + 1}`}

            <button onClick={(e) => this.handleOpenMenu(e, item)}>⋮</button>
          </div>
        ))}

        <FLOAT_MENU
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleCloseMenu}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "5px",
              alignItems: "flex-start",
            }}
          >
            <button
              className="button_big button_white"
              onClick={this.handleEdit}
            >
              Ubah nama
            </button>
            <button
              className="button_big button_white"
              onClick={this.handleDelete}
            >
              Hapus
            </button>
          </div>
        </FLOAT_MENU>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  layer: state.layer,
  project: state.project,
  loading_reducer: state.loading_reducer,
  sini_data_reducer: state.sini_data_reducer,
});

export default connect(mapStateToProps, {
  set_value_sini_data,
  get_history_sini_data,
  delete_item_sini_data,
  edit_title_sini_data,
})(S_D_HISTORY);
